<template>
  <div
    v-if="currentRouteName !== 'line-oa'"
    class="mr-50 cursor-pointer"
    @click="onClick"
  >
    <feather-icon
      size="20"
      icon="GridIcon"
      style="margin-top: -3px;"
    />
    <span class="ml-50 text-body">{{ $t('LINE OA') }}</span>
  </div>
</template>

<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    FeatherIcon,
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
  },
  methods: {
    onClick() {
      this.$router.push({ name: 'line-oa', params: { prevRoute: '' } })
    },
  },
}
</script>

<style>

</style>
